// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IForfeitureDaysPropertyDto
 */
export interface IForfeitureDaysPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IForfeitureDaysPropertyDto
     */
    forfeiture_days?: number;
    /**
     * 
     * @type {string}
     * @memberof IForfeitureDaysPropertyDto
     */
    forfeiture_days_state?: IForfeitureDaysPropertyDtoForfeitureDaysStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IForfeitureDaysPropertyDtoForfeitureDaysStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IForfeitureDaysPropertyDto interface.
 */
export function instanceOfIForfeitureDaysPropertyDto(value: object): value is IForfeitureDaysPropertyDto {
    return true;
}

export function IForfeitureDaysPropertyDtoFromJSON(json: any): IForfeitureDaysPropertyDto {
    return IForfeitureDaysPropertyDtoFromJSONTyped(json, false);
}

export function IForfeitureDaysPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IForfeitureDaysPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'forfeiture_days': json['forfeiture_days'] == null ? undefined : json['forfeiture_days'],
        'forfeiture_days_state': json['forfeiture_days_state'] == null ? undefined : json['forfeiture_days_state'],
    };
}

export function IForfeitureDaysPropertyDtoToJSON(json: any): IForfeitureDaysPropertyDto {
    return IForfeitureDaysPropertyDtoToJSONTyped(json, false);
}

export function IForfeitureDaysPropertyDtoToJSONTyped(value?: IForfeitureDaysPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'forfeiture_days': value['forfeiture_days'],
        'forfeiture_days_state': value['forfeiture_days_state'],
    };
}

